import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import "../css/Admin_css/admin-customize.css";
import StudentInformation from "../ChildComponent/StudentInformation";
import PaymentHistory from "./PaymentHistory";
import PaymentDetails from "./PaymentDetails";
import TestModal from "../dialog/TestModal";

import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Button, Form } from "react-bootstrap";
import DueFeeCollection from "../ChildComponent/DueFeeCollection";
import MdlFeePaymentStatus from "../dialog/MdlFeePaymentStatus";

import {
  BrowserRouter as Router,
  Link,
  Redirect,
  Route,
} from "react-router-dom";
import FeeCard from "./FeeCard";
import MdlSelectSingleStudent from "../dialog/MdlSelectSingleStudent";
import ModalFeeConfirmation from "../dialog/ModalFeeConfirmation";
import FeeOtherAmount from "./FeeOtherAmount";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import MdlSearchStudent from "../dialog/MdlSearchStudent";
import BackButton from "../ChildComponent/BackButton";

const FeeCollection = () => {
  const slt_board = useRef(null);
  const slt_medium = useRef(null);

  const [isOpenStudentSelector, setIsOpenStudentSelector] = useState(false);
  const [isOpenStudentSearch, setIsOpenStudentSearch] = useState(false);
  const [loggedIn, setLoggedIn] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [showStudentInfo, setShowStudentInfo] = useState(false);
  const [showDueFee, setShowDueFee] = useState(false);
  const [status, setStatus] = useState(false);
  const [mClassData, setMClassData] = useState([]);
  const [mClassBoard, setMClassBoard] = useState([]);
  const [mClassMedium, setMClassMedium] = useState([]);
  const [mFilteredClassSectionList, setMFilteredClassSectionList] = useState([]);
  const [mFilteredClassList, setMFilteredClassList] = useState([]);
  const [mStudentDetails, setMStudentDetails] = useState([]);
  const [mStudentClass, setMStudentClass] = useState([]);
  const [mStudentFeeDetails, setMStudentFeeDetails] = useState([]);
  const [ENROLLMENT_NO, setENROLLMENT_NO] = useState("");
  const [ADHAAR_NO, setADHAAR_NO] = useState("");
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [SESSION_NAME, setSESSION_NAME] = useState("");
  const [TRANSACTION_ID, setTRANSACTION_ID] = useState("");
  const [current_due, setCurrent_due] = useState("");
  const [enableEnrollmentSearch, setEnableEnrollmentSearch] = useState(true);
  const [showEnrollmentSearchCard, setShowEnrollmentSearchCard] = useState(true);
  const [showPaymentStatus, setShowPaymentStatus] = useState(false);
  const [lastCollectedAmount, setLastCollectedAmount] = useState(0);
  const [feeRequestType, setFeeRequestType] = useState("CURRENT");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.onpopstate = (e) => {
      getStudentFeeDetails();
    };
    return () => {
      window.onpopstate = null;
    };
  });


  const onStudentIdChange = useCallback((e) => {
    setENROLLMENT_NO(e.target.value);
  }, []);

  const onAdhaarChange = useCallback((e) => {
    setADHAAR_NO(e.target.value);
  }, []);

  const setCurrentDue = useCallback((due) => {
    setCurrent_due(due);
    setShowStudentInfo(true);
  }, []);

  const getStudentFeeDetails = useCallback((overrides = {}) => {
    const requestType = overrides.request_type ?? "CURRENT";
    setFeeRequestType(requestType);
    setLoading(true);
    setMStudentDetails([]);
    setMStudentFeeDetails([]);
    setShowStudentInfo(false);
    setShowDueFee(false);

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getStudentFeeDetailsNew.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      session_id: overrides.session_id ?? SESSION_ID,
      enrollment_no: overrides.enrollment_no ?? ENROLLMENT_NO,
      aadhar_no: overrides.aadhar_no ?? ADHAAR_NO,
      request_type: requestType,
    };
    const queryString = new URLSearchParams(params).toString();
    console.log("Full URL: ", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        let api_status = response.api_status;
        if (api_status == "OK") {
          setMStudentDetails(response.data);
          setMStudentFeeDetails(response.data[0].fee_details);
          setShowDueFee(true);
        } else {
          let api_remark = response.api_remark;
          myToast.notify_warning(api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error>>>>>" + error);
      });
  }, [ADHAAR_NO, ENROLLMENT_NO, SESSION_ID]);

  const getStudentFeeDetailsBySearch = useCallback(() => {
    var mSession = SessionManager.getCurrentSession();
    var session_id = mSession[0].session_id;
    var session_name = mSession[0].session_name;
    setSESSION_ID(session_id);
    setSESSION_NAME(session_name);
    // Fetch immediately with explicit values to avoid race with async state
    getStudentFeeDetails({ session_id, enrollment_no: ENROLLMENT_NO, aadhar_no: ADHAAR_NO, request_type: "CURRENT" });
  }, [getStudentFeeDetails, ENROLLMENT_NO, ADHAAR_NO]);

  const handlerFeeSubmit = useCallback((mstatus, transaction_id, collectedAmount = 0) => {
    if (mstatus && transaction_id) {
      const enrollment = mStudentDetails[0].student_enrollment_no;
      const sessionId = mStudentDetails[0].class[0].session_id;
      const sessionName = mStudentDetails[0].class[0].session_name;
      setENROLLMENT_NO(enrollment);
      setSESSION_ID(sessionId);
      setSESSION_NAME(sessionName);
      setTRANSACTION_ID(transaction_id);
      setLastCollectedAmount(collectedAmount);
      setShowPaymentStatus(true);
    }
    setStatus(mstatus);
  }, [mStudentDetails]);


  const HandleShow = useCallback(() => {
    setIsOpenStudentSelector((v) => !v);
    setShowEnrollmentSearchCard(false);
  }, []);

  const HandleClose = useCallback(() => {
    setIsOpenStudentSelector(false);
  }, []);

  const HandleShowStudentSearch = useCallback(() => {
    setIsOpenStudentSearch((v) => !v);
    setShowEnrollmentSearchCard(false);
  }, []);

  const HandleCloseStudentSearch = useCallback(() => {
    setIsOpenStudentSearch(false);
  }, []);

  const HandleSelectedStudent = useCallback((
    student_id,
    selected_item,
    session_id,
    session_name
  ) => {
    setENROLLMENT_NO(student_id);
    setSESSION_ID(session_id);
    setSESSION_NAME(session_name);
    setIsOpenStudentSelector(false);
    setIsOpenStudentSearch(false);
    // Fetch with explicit IDs to ensure correct request
    getStudentFeeDetails({ session_id, enrollment_no: student_id, aadhar_no: ADHAAR_NO, request_type: "CURRENT" });
  }, [getStudentFeeDetails, ADHAAR_NO]);

  const HandleSelectedSessionPayDtls = useCallback((session_id, session_name) => {
    setSESSION_ID(session_id);
    setSESSION_NAME(session_name);
    setIsOpenStudentSelector(false);
    // Use current enrollment_no and new session id
    getStudentFeeDetails({ session_id, enrollment_no: ENROLLMENT_NO, aadhar_no: ADHAAR_NO, request_type: "CURRENT" });
  }, [getStudentFeeDetails, ENROLLMENT_NO, ADHAAR_NO]);

  const handleAdvancedPayment = useCallback((enrollmentNo, sessionId) => {
    const enrollment = enrollmentNo || ENROLLMENT_NO;
    const session_id = sessionId || SESSION_ID;
    if (!enrollment || !session_id) {
      myToast.notify_warning("Student session not found.");
      return;
    }

    setENROLLMENT_NO(enrollment);
    setSESSION_ID(session_id);

    getStudentFeeDetails({
      session_id,
      enrollment_no: enrollment,
      aadhar_no: ADHAAR_NO,
      request_type: "ADVANCE",
    });
  }, [getStudentFeeDetails, ENROLLMENT_NO, SESSION_ID, ADHAAR_NO]);

  const HandleSelectedSiblingPayDtls = useCallback((sibling_enrollment, sibling_name) => {
    // Get current session from the current student details or use SESSION_ID
    const currentSessionId = mStudentDetails[0]?.class[0]?.session_id || SESSION_ID;
    const currentSessionName = mStudentDetails[0]?.class[0]?.session_name || SESSION_NAME;
    
    setENROLLMENT_NO(sibling_enrollment);
    setSESSION_ID(currentSessionId);
    setSESSION_NAME(currentSessionName);
    setIsOpenStudentSelector(false);
    setIsOpenStudentSearch(false);
    // Fetch fee details for the sibling student
    getStudentFeeDetails({ session_id: currentSessionId, enrollment_no: sibling_enrollment, aadhar_no: ADHAAR_NO, request_type: feeRequestType });
  }, [getStudentFeeDetails, mStudentDetails, SESSION_ID, SESSION_NAME, ADHAAR_NO, feeRequestType]);

  if (loggedIn == false) {
    return <Redirect to="/Login" />;
  } else if (Loading) {
    return <MyLoader />;
  } else {
    return (
      <Router>
        <Route
          path="/AdminMain/FeeCollection"
          exact
          render={() => {
            return (
              <div className="content">
                <div className="content-header d-flex align-items-center justify-content-between">
                  <div className="leftside-content-header">
                    <ul className="breadcrumbs">
                      <li>
                        <i className="fa fa-credit-card" aria-hidden="true" />
                        <a href="#">Fee Collection</a>
                      </li>
                    </ul>
                  </div>
                  <BackButton />
                </div>

                <div
                  className="bg_page_white_rounded box_shadow animated fadeInUp"
                  style={{
                    "--mMargin": "30px",
                    padding: 0,
                    overflow: "hidden",
                    borderRadius: "14px",
                  }}
                >
                  <div className="pb-4">
                    <div className="row justify-content-center gx-0">
                      <div className="col-12 px-0">
                        {/* Gradient header - matches modern pattern from StaffRegistration */}
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{
                            background: COLORS.primary_color_shade7,
                            borderRadius: "14px 14px 0 0",
                            padding: "12px 18px",
                            boxShadow: "0 10px 25px rgba(15, 23, 42, 0.25)",
                            color: "#fff",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <span
                              className="d-inline-flex align-items-center justify-content-center rounded-circle"
                              style={{
                                width: 40,
                                height: 40,
                                backgroundColor: "rgba(255,255,255,0.18)",
                              }}
                            >
                              <i className="fa fa-credit-card" />
                            </span>
                            <div>
                              <h5 className="mb-0" style={{ fontWeight: 600 }}>
                                Fee Collection
                              </h5>
                              <small style={{ opacity: 0.9 }}>
                                Select a student to view dues and collect fees.
                              </small>
                            </div>
                          </div>
                          <Button
                            variant="light"
                            size="sm"
                            onClick={HandleShowStudentSearch}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = `0 10px 25px rgba(15,23,42,0.35)`;
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = `0 0 0 1px ${COLORS.highlight_color2}, 0 0 18px ${COLORS.highlight_color2}`;
                            }}
                            style={{
                              borderRadius: "999px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                              padding: "8px 24px",
                              fontSize: "14px",
                              fontWeight: 600,
                              minWidth: "190px",
                              backgroundColor: "#ffffff",
                              border: `2px solid ${COLORS.highlight_color2}`,
                              color: COLORS.primary_color_shade7,
                              boxShadow: `0 4px 10px rgba(15,23,42,0.18)`,
                              transition: "all 0.22s ease",
                            }}
                          >
                            <span
                              style={{
                                width: 26,
                                height: 26,
                                borderRadius: "999px",
                                backgroundColor: "rgba(15,23,42,0.04)",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                              }}
                            >
                              <i className="fa fa-search" />
                            </span>
                            <span>Search By Name</span>
                          </Button>
                        </div>

                        {/* Card body */}
                        <div
                          style={{
                            padding: "16px 20px",
                          }}
                        >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                marginBottom: "12px",
                                flexWrap: "nowrap",
                              }}
                            >
                              <Button
                                onClick={HandleShow}
                                variant="primary"
                                style={{
                                  borderRadius: "999px",
                                  whiteSpace: "nowrap",
                                  background: COLORS.primary_color_shade5,
                                  color: "#fff",
                                  borderColor: COLORS.primary_color_shade5,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "6px",
                                  padding: "8px 14px",
                                  flexShrink: 0,
                                }}
                              >
                                <span
                                  style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: "50%",
                                    backgroundColor: "rgba(255,255,255,0.16)",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <i className="fa fa-user-plus" />
                                </span>
                                <span>Select Students Manually</span>
                              </Button>
                              <Button
                                onClick={() => {
                                  setShowEnrollmentSearchCard((prev) => !prev);
                                  setEnableEnrollmentSearch((prev) => !prev);
                                }}
                                variant={showEnrollmentSearchCard ? "success" : "outline-secondary"}
                                style={{
                                  borderRadius: "999px",
                                  whiteSpace: "nowrap",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "6px",
                                  padding: "8px 14px",
                                  fontSize: "13px",
                                  flexShrink: 0,
                                  height: "auto",
                                }}
                              >
                                <span
                                  style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: "50%",
                                    backgroundColor: showEnrollmentSearchCard
                                      ? "rgba(255,255,255,0.2)"
                                      : "transparent",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: showEnrollmentSearchCard
                                      ? "none"
                                      : "1px solid #9ca3af",
                                  }}
                                >
                                  <i className="fa fa-id-card" />
                                </span>
                                <span>Search By Enrollment No</span>
                              </Button>
                            </div>

                            {/* Enrollment search */}
                            {showEnrollmentSearchCard && (
                              <div
                                style={{
                                  backgroundColor: "#ffffff",
                                  borderRadius: "14px",
                                  border: "1px solid #e5e7eb",
                                  boxShadow: "0 8px 20px rgba(15,23,42,0.08)",
                                  padding: "12px 14px",
                                }}
                              >
                                <div
                                  className="row align-items-center"
                                  style={{ rowGap: "10px" }}
                                >
                                  <div className="col-md-5">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: 30,
                                          height: 30,
                                          borderRadius: "999px",
                                          backgroundColor:
                                            "rgba(3,169,244,0.10)",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          color: COLORS.primary_color_shade7,
                                        }}
                                      >
                                        <i className="fa fa-id-badge" />
                                      </div>
                                      <div style={{ flex: 1, minWidth: 0 }}>
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#111827",
                                            marginBottom: "2px",
                                          }}
                                        >
                                          Search By Enrollment No
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "#6b7280",
                                          }}
                                        >
                                          Type an enrollment number and click
                                          Search to load fee details.
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <Form.Group className="match_parent">
                                      <Form.Control
                                        placeholder="Enter enrollment number"
                                        aria-label="Enrollment Number"
                                        value={ENROLLMENT_NO}
                                        onChange={onStudentIdChange}
                                        style={{
                                          padding: "10px 12px",
                                          fontSize: "16px",
                                          width: "100%",
                                          borderRadius: "10px",
                                          height: "44px",
                                          boxShadow:
                                            "0 1px 2px rgba(15, 23, 42, 0.08)",
                                        }}
                                      />
                                    </Form.Group>
                                  </div>

                                  <div className="col-md-3">
                                    <Form.Group className="match_parent">
                                      <Button
                                        className="search-text"
                                        onClick={getStudentFeeDetailsBySearch}
                                        variant="primary"
                                        style={{
                                          width: "100%",
                                          borderRadius: "999px",
                                          padding: "10px 12px",
                                          fontSize: "16px",
                                          background: COLORS.primary_color_shade5,
                                          color: "#fff",
                                          borderColor:
                                            COLORS.primary_color_shade5,
                                          height: "44px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            width: 26,
                                            height: 26,
                                            borderRadius: "50%",
                                            backgroundColor:
                                              "rgba(255,255,255,0.16)",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <i className="fa fa-search" />
                                        </span>
                                        <span>Search</span>
                                      </Button>
                                    </Form.Group>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                      </div>
                    </div>

                    {showStudentInfo === true && ENROLLMENT_NO && SESSION_ID ? (
                      <div style={{ margin: "12px 20px 0 20px" }}>
                        <StudentInformation
                          showStudentInfo={showStudentInfo}
                          mStudentDetails={mStudentDetails}
                          current_due={current_due}
                          action_advanced_payment={handleAdvancedPayment}
                        ></StudentInformation>
                      </div>
                    ) : (
                      ""
                    )}

                    {showDueFee === true && mStudentDetails.length > 0 ? (
                      <DueFeeCollection
                        showDueFee={showDueFee}
                        FeeDetails={mStudentFeeDetails}
                        mStudentDetails={mStudentDetails}
                        action={handlerFeeSubmit}
                        action_session_pay_dtls={HandleSelectedSessionPayDtls}
                        action_sibling_pay_dtls={HandleSelectedSiblingPayDtls}
                        action_set_current_due={setCurrentDue}
                      ></DueFeeCollection>
                    ) : (
                      ""
                    )}

                    {isOpenStudentSelector === true ? (
                      <MdlSelectSingleStudent
                        action={HandleClose}
                        action2={HandleSelectedStudent}
                      ></MdlSelectSingleStudent>
                    ) : (
                      ""
                    )}
                    {isOpenStudentSearch === true ? (
                      <MdlSearchStudent
                        actionClose={HandleCloseStudentSearch}
                        actionDone={HandleSelectedStudent}
                      ></MdlSearchStudent>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            );
          }}
        />

        <Route
          path="/AdminMain/PaymentHistory/:student_id/:session_id/:session_name"
          component={PaymentHistory}
        />
        <Route
          path="/AdminMain/FeeCard/:enrollment_no?/:session_id?"
          component={FeeCard}
        />
        <Route
          path="/AdminMain/FeeOtherAmount"
          component={FeeOtherAmount}
        />

        {/* Payment Status Modal */}
        {showPaymentStatus && TRANSACTION_ID && (
          <MdlFeePaymentStatus
            show={showPaymentStatus}
            onClose={() => {
              setShowPaymentStatus(false);
              // Refresh student fee details after closing modal
              if (ENROLLMENT_NO && SESSION_ID) {
                getStudentFeeDetails({
                  session_id: SESSION_ID,
                  enrollment_no: ENROLLMENT_NO,
                  aadhar_no: ADHAAR_NO,
                  request_type: feeRequestType,
                });
              }
            }}
            transactionId={TRANSACTION_ID}
            studentId={ENROLLMENT_NO}
            sessionId={SESSION_ID}
            sessionName={SESSION_NAME}
            collectedAmount={lastCollectedAmount}
          />
        )}
      </Router>
    );
  }
};

export default FeeCollection;
